export const isDateValid = (date: Date): boolean => date instanceof Date && !Number.isNaN(date.getTime());

export const isValidDateTimeMask = (dateString: string): boolean => {
  const iso8601Regex = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?Z)$/;

  if (!iso8601Regex.test(dateString)) {
    return false;
  }

  const date = new Date(dateString);

  return !Number.isNaN(date.getTime());
};

export const isValidDateMask = (dateString: string): boolean => {
  const regexDate = /^\d{4}-\d{2}-\d{2}$/;

  if (!regexDate.test(dateString)) return false;

  const date = new Date(dateString);

  return !Number.isNaN(date.getTime());
};
